<template>
    <div class="qa-box">
        <div class="title-bar">
            <div class="title" :class="{'no-timer': ! timerRequired}">{{qaData.qa.title}}</div>
            <div class="stat-info" v-if="!isHistory">
                <span>已参与</span>
                <span>{{qaData.memberCount}}</span>
            </div>
            <!-- <button @click="scrollToTop">点击滚动条</button> -->
        </div>

        <!-- no one answered the question -->
        <div v-if="!hasResults" ref="emptyResultHintBox" class="empty-result-hint">
            <div class="hint-content">{{ hintContent }}</div>
        </div>

        <div ref="positions" class="positions">
            <div ref="resultsTitle" v-if="hasTopic" class="results-title">
                <div class="text-content">
                    <span v-html="'主题: ' + qaData.qa.subject"></span> 
                </div>
            </div>

            <div v-if="hasResults" ref="resultsBox" class="results-box">
                <div class="result-main" v-for="(item,index) in results" :key="index.msgId" :id="'result-box-' + item.msgId">

                    <div class="result-time">{{item.stamp}}</div>

                    <div class="result-body" :class="getRoleClass(item.user)">
                        <div class="user-box" :id="'result-img-box-' + item.miUuid">
                            <img class="user-img" :src="item.user.avatarUrl ? item.user.avatarUrl : userAvatarUrl">
                        </div>

                        <!-- teacher and student -->
                        <div class="result-content">
                            <p v-if="item.user.roleId === consts.SUPERVISOR" class="user-title supervisor" >
                                <span class="user-flag supervisor-flag">观摩者</span>
                                <span class="user-fn"> {{item.user.fullName}} </span>
                            </p>
                            <p v-if="item.user.roleId === 3" class="user-title student assistant" >
                                <span class="user-flag assistant-flag">助教</span>
                                <span class="user-fn"> {{item.user.fullName}} </span>
                                <span class="user-no"> {{item.user.studentNo}}</span>
                            </p>
                            <p v-if="item.user.roleId === 2" class="user-title student" >
                                <span class="user-fn"> {{item.user.fullName}} </span>
                                <span class="user-no"> {{item.user.studentNo}}</span>
                            </p>
                            <p v-if="item.user.roleId === 1 || item.user.roleId === consts.TEAM_TEACHER" class="user-title teacher">
                                <span class="user-flag teacher-flag">老师</span>
                                <span class="user-fn"> {{item.user.fullName}} </span>
                            </p>
                            
                            <div class="result-msg" :class="item.user.userId === userId ? 'teach-result-msg' : 'stu-result-msg'">
                                <!-- 被解答的内容 -->
                                <div v-if="item.refMsg !== null" class="ref-msg-box" :class="[{'img-left' : item.user.roleId === 1 && item.refMsg.msgType === 'img', 'video-left': item.user.roleId === 1 && item.msgType === 'video'}]">
                                    <div v-if="item.refMsg.msgType === 'img' " class="ref-img-box" 
                                        :class="[{'img-left' : item.user.roleId === 1 && item.refMsg.msgType === 'img'}]" 
                                        :style="item.refMsg.imageBoxStyleString">
                                        <img :src="item.refMsg.attachmentUrl" :style="item.refMsg.imageStyleString">
                                    </div>

                                    <div v-if="item.refMsg.msgType === 'audio'" class="ref-audio-box">
                                        <div>
                                            <svg v-if="!item.refMsg.isPlay" width="25px" height="36px" viewBox="0 0 50 72" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :style="item.user.roleId === 1 ? 'transform: rotate(0deg)' : 'transform: rotate(180deg)'">
                                                <title>voice_icon_white@2x</title>
                                                <desc>Created with Sketch.</desc>
                                                <defs></defs>
                                                <g id="voice_icon_white" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.6" class="voice-icon">
                                                    <path d="M44.5454545,36 C44.5454545,47.9032258 40.1818182,59.2258065 32.2727273,67.9354839 L34.1818182,69.9677419 L36.0909091,72 C45.0909091,62.4193548 50,49.6451613 50,36 C50,22.3548387 45.0909091,9.87096774 36.0909091,0.290322581 L35.8181818,0 L33.9090909,2.03225806 L32,4.06451613 L32.2727273,4.35483871 C40.1818182,12.7741935 44.5454545,24.0967742 44.5454545,36 Z" id="Shape" transform="translate(41.000000, 36.000000) scale(-1, 1) rotate(-180.000000) translate(-41.000000, -36.000000) "></path>
                                                    <path d="M22.3004695,58.0434783 C22.3004695,58.0434783 22,58.0434783 22.3004695,58.0434783 L24.4037559,60.0217391 L26.5070423,62 C41.8309859,47.5869565 41.8309859,24.4130435 26.5070423,10.2826087 L26.2065728,10 L24.1032864,11.9782609 L22,13.9565217 L22.3004695,14.2391304 C34.9201878,26.3913043 34.9201878,45.8913043 22.3004695,58.0434783 Z" id="Shape" transform="translate(30.000000, 36.000000) scale(-1, 1) rotate(-180.000000) translate(-30.000000, -36.000000) "></path>
                                                    <path d="M13.154519,49.8688525 C13.154519,50.1639344 13.154519,50.1639344 13.154519,49.8688525 L15.1137026,51.9344262 L17.0728863,54 C26.3090379,44.2622951 26.3090379,28.3278689 17.0728863,18.295082 L16.7930029,18 L14.8338192,20.0655738 L12.8746356,22.1311475 L13.154519,22.4262295 C20.4314869,30.3934426 20.4314869,42.4918033 13.154519,49.8688525 Z M7.55685131,43.9672131 C11.4752187,39.8360656 11.4752187,33.0491803 7.55685131,28.9180328 L7.27696793,28.6229508 L0,36.295082 L7.55685131,43.9672131 C7.27696793,43.9672131 7.27696793,43.9672131 7.55685131,43.9672131 Z" id="Shape" transform="translate(12.000000, 36.000000) scale(-1, 1) rotate(-180.000000) translate(-12.000000, -36.000000) "></path>
                                                </g>
                                            </svg>
                                            <img v-if="item.refMsg.isPlay" :src="item.user.roleId === 1 ? voiceImgTeachRef : voiceImgStuRef" alt="">
                                        </div>
                                        <div v-if="item.refMsg.attachmentDuration"> {{item.refMsg.attachmentDuration ? item.refMsg.attachmentDuration : '55'}}”</div>
                                    </div>

                                    <div v-if="item.refMsg.msgType === 'video'" class="res-video-box">
                                        <div class="video-img-box" :class="{'video-img-box-model': item.refMsg.isLoaded}">
                                            <img :src="item.refMsg.attachmentUrl" :style="item.refMsg.imageStyleString" @load="imgLoad(item.refMsg)">
                                            <img class="video-play-icon" :src="videoPlayIcon" alt="" v-show="item.refMsg.isLoaded">
                                            <span class="video-duration" v-show="item.refMsg.isLoaded">{{ parseSecond(item.refMsg.attachmentDuration) }}</span>
                                        </div>
                                    </div>

                                    <p v-if="item.refMsg.msgType == 'txt'" v-html="item.refMsg.content"></p>
                                </div>

                                <!-- 解答/正常发表的内容 -->
                                <div class="res-msg-box" :class="[{'img-left' : item.user.roleId === 1 && item.msgType === 'img', 'video-left': item.user.roleId === 1 && item.msgType === 'video'}]">
                                    <div v-if="item.msgType === 'img' " class="res-img-box" :style="item.imageBoxStyleString">
                                        <img :src="item.attachmentUrl" :style="item.imageStyleString">
                                    </div>

                                    <div v-if="item.msgType === 'audio' " class="res-audio-box">
                                        <div>
                                            <svg v-if="!item.isPlay" width="25px" height="36px" viewBox="0 0 50 72" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform-origin: center center;" :style="item.user.roleId === 1 ? 'transform: rotate(180deg)' : 'transform: rotate(0deg)'">
                                                <title>voice_icon_white@2x</title>
                                                <desc>Created with Sketch.</desc>
                                                <defs></defs>
                                                <g id="voice_icon_white" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.6" class="voice-icon">
                                                    <path d="M44.5454545,36 C44.5454545,47.9032258 40.1818182,59.2258065 32.2727273,67.9354839 L34.1818182,69.9677419 L36.0909091,72 C45.0909091,62.4193548 50,49.6451613 50,36 C50,22.3548387 45.0909091,9.87096774 36.0909091,0.290322581 L35.8181818,0 L33.9090909,2.03225806 L32,4.06451613 L32.2727273,4.35483871 C40.1818182,12.7741935 44.5454545,24.0967742 44.5454545,36 Z" id="Shape" ></path>
                                                    <path d="M22.3004695,58.0434783 C22.3004695,58.0434783 22,58.0434783 22.3004695,58.0434783 L24.4037559,60.0217391 L26.5070423,62 C41.8309859,47.5869565 41.8309859,24.4130435 26.5070423,10.2826087 L26.2065728,10 L24.1032864,11.9782609 L22,13.9565217 L22.3004695,14.2391304 C34.9201878,26.3913043 34.9201878,45.8913043 22.3004695,58.0434783 Z" id="Shape" ></path>
                                                    <path d="M13.154519,49.8688525 C13.154519,50.1639344 13.154519,50.1639344 13.154519,49.8688525 L15.1137026,51.9344262 L17.0728863,54 C26.3090379,44.2622951 26.3090379,28.3278689 17.0728863,18.295082 L16.7930029,18 L14.8338192,20.0655738 L12.8746356,22.1311475 L13.154519,22.4262295 C20.4314869,30.3934426 20.4314869,42.4918033 13.154519,49.8688525 Z M7.55685131,43.9672131 C11.4752187,39.8360656 11.4752187,33.0491803 7.55685131,28.9180328 L7.27696793,28.6229508 L0,36.295082 L7.55685131,43.9672131 C7.27696793,43.9672131 7.27696793,43.9672131 7.55685131,43.9672131 Z" id="Shape" ></path>
                                                </g>
                                            </svg>
                                            <img v-if="item.isPlay" :src="item.user.roleId === 1 ? voiceImg : voiceImgStu"> 
                                        </div>
                                        <div> {{ item.attachmentDuration }}”</div>
                                        <!-- <audio :src="item.attachmentUrl" :id="'result-audio-' + item.miUuid"></audio> -->
                                    </div>

                                    <div v-if="item.msgType === 'video'" class="res-video-box">
                                        <div class="video-img-box" :class="{'video-img-box-model': item.isLoaded}">
                                            <img :src="item.attachmentUrl" :style="item.imageStyleString" @load="imgLoad(item)">
                                            <img class="video-play-icon" :src="videoPlayIcon" alt="" v-show="item.isLoaded">
                                            <span class="video-duration" v-show="item.isLoaded">{{ parseSecond(item.attachmentDuration) }}</span>
                                        </div>
                                    </div>

                                    <p v-if="item.msgType === 'txt'" class="res-answer">
                                        <span v-if="item.refMsg" class="has-answer">解答 {{ item.refMsg.user.fullName }} :</span>
                                        <span v-html="item.content"></span>
                                    </p>
                                </div>
                            </div>
                            <div v-if="item.likeScore > 0" class="result-like-score">+ {{ item.likeScore }} 经验值</div>
                        </div>

                        <div class="like-Count" :class="{'like-position': item.likeScore > 0}">
                            <div class="result-like-count" :class="item.likeCount ? 'stu-like-count' : ''"></div>
                            <div v-if="item.likeCount" class="result-like-count1" :class="item.likeCount > 0 ? 'stu-like-count1' : ''"> {{ item.likeCount }} </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="selectedImage != null" class="expand-image-box">
            <img ref="selectedImage" :src="selectedImage.src" :style="selectedImage.styleString">
        </div>

        <div v-if="selectedAudio != null" class="expand-audio-box">
            <audio ref="selectedAudioBox" :src="selectedAudio.src"></audio>
        </div>

        <div v-if="selectedVideo != null" class="expand-video-box">
            <resourceVideo :qaFilesData="selectedVideo" :id="currentShow" :currentShow="currentShow"></resourceVideo>
        </div>
    </div>
</template>

<script>
import resourceVideo from '@/components/resourceVideo'

import userAvatarUrl from '../assets/image/user-avatarUrl.jpg';
import loading from '@/assets/image/loading.png';
import voiceImg from '@/assets/image/voice.gif';
import voiceImgStu from '@/assets/image/voice-stu.gif';
import voiceImgStuRef from '@/assets/image/voice-stu-ref.gif';
import voiceImgTeachRef from '@/assets/image/voice-teach-ref.gif';
import videoPlayIcon from '@/assets/image/qa-video-play.png'

import moment from 'moment';
import tool from '@/assets/scripts/tool.js';
import Wings from '../assets/scripts/wings.js';


export default {
    components: {
        resourceVideo
    },
    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        currentShow: {
            type: String,
            default: ''
        },
        userId: {
            type: String,
            default: ''
        }
    },
    

    data: function() {
        return {
            consts: tool.consts,
            userAvatarUrl: userAvatarUrl,
            loading: loading,
            voiceImg: voiceImg,
            voiceImgStu: voiceImgStu,
            voiceImgStuRef: voiceImgStuRef,
            voiceImgTeachRef: voiceImgTeachRef,
            
            timerRequired: false,

            qaId: '',
            isHistory: false,
            isShow: false,
            qaData: {
                qa:{
                    title: '',
                },
            },
            videoPlayIcon,
            results: [],

            bgColors: [
                '#D18400',
                '#4A7FB5',
                '#3C896D',
                '#C56073',
                '#AA8748',
                '#6E748C'
            ],
            supportedEventNames: [
                'activity.qa.show',
                'activity.qa.showHistory',
                'activity.qa.showTopic',
                'activity.qa.hideTopic',
                'activity.qa.revokeMsg',
                'activity.qa.sendMsg',
                'activity.qa.like',
                'activity.qa.cancelLike',
                'activity.qa.showFiles',
                'activity.qa.hideFiles',
                'activity.qa.showRefFiles',
                'activity.qa.hideRefFiles',
                'files.zoom',
                'files.rotate',
                'common.moveJoystick'
            ],
            memberCount: 0,
            selectedImage: null,
            selectedImageScale: null,
            moveX: 0,
            moveY: 0,
            rotate: 0,
            hasTopic: false,
            maxBottom: 399,
            wings: null,
            selectedAudio: null,
            selectedVideo: null,
        };
    },

    computed: {
        hintContent: function() {
            return this.qaData.qa.status === 'END' ? '很遗憾，没有人参与答疑讨论' : '快来参与讨论吧~';
        },

        // allSubmitted: function() {
        //     return (this.memberCount <= this.activity.results.length);
        // },

        hasResults: function() {
            return this.results.length > 0 ? true : false;
        },

    },

    watch:{
        currentShow (newVal, oldVal) {
            if (newVal !== this.componentId && oldVal === this.componentId) {
                this.resetScene();
            }
        },
    },


    created: function() {
        this.wings = new Wings();
        window.addEventListener('message', this.windowMessageHandler);
    },

    mounted: function() {
        this.componentId = this.$attrs.id;
        
        // window.addEventListener('message', this.windowMessageHandler);
    },

    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
    },

    
    methods: {
        windowMessageHandler: function(e) {
            let msg = e.data;
            if (!msg.eventName) return;
            if (this.supportedEventNames.indexOf(msg.eventName) === -1) return;
            
            let msgData = msg.data;

            // Lock status, do not respond to any message
            // if (this.isLock && this.currentShow === this.componentId) return;
            // if (!this.isLock && this.currentShow !== this.componentId) return;
            // console.log(msg.eventName)
            switch (msg.eventName) {
                case 'activity.qa.show':
                    if (this.isLock) return;
                    this.handleShowMessage(msgData);
                    break;
                case 'activity.qa.showHistory':
                    if (msgData.id !== this.qaId) return;
                    this.handleHistoryMessage(msgData);
                    break;
                case 'activity.qa.showTopic':
                    if (msgData.id !== this.qaId) return;
                    if (!this.qaData.qa.subject) return;
                    if (this.isLock) return;

                    this.expandResult();
                    break;
                case 'activity.qa.hideTopic':
                    if (msgData.id !== this.qaId) return;
                    if (this.isLock) return;

                    this.collapseResult();
                    break;
                case 'activity.qa.revokeMsg':
                    if (msgData.id !== this.qaId) return;
                    this.handleRevokMessage(msgData);
                    break;
                case 'activity.qa.sendMsg':
                    if (msgData.id !== this.qaId) return;
                    this.handleNewMessage(msgData);
                    break;
                case 'activity.qa.like':
                    if (msgData.id !== this.qaId) return;
                    this.handleLikeMessage(msgData);
                    break;
                case 'activity.qa.cancelLike':
                    if (msgData.id !== this.qaId) return;
                    this.handleCancelLikeMessage(msgData);
                    break;
                case 'activity.qa.showFiles':
                    if (msgData.entityId !== this.qaId) return;
                    if (this.isLock) return;

                    this.handleShowFiles(msgData);
                    break;
                case 'activity.qa.hideFiles':
                    if (msgData.entityId !== this.qaId) return;
                    if (this.isLock) return;

                    this.handleHideFiles(msgData);
                    break;
                case 'activity.qa.showRefFiles':
                    if (msgData.entityId !== this.qaId) return;
                    if (this.isLock) return;

                    this.handleShowFiles(msgData);
                    break;
                case 'activity.qa.hideRefFiles':
                    if (msgData.entityId !== this.qaId) return;
                    if (this.isLock) return;

                    this.handleHideFiles(msgData);
                    break;
                case 'files.zoom':
                    this.zoomTo(msgData);
                    break;
                case 'files.rotate':
                    this.rotateImg(msgData);
                    break;
                case 'common.moveJoystick':
                    this.moveJoystick(msgData);
                    break;
                default:
                    console.log('I don\'t understand this event ', msg.eventName);
            }
        },
        
        /**
         * video thumb load event
         * @param {object} item msg body
         */
        imgLoad(item) {
            if (!item) return;
            this.$set(item, 'isLoaded', true);
        },
        resetScene: function() {
            this.memberCount = 0;
            this.qaData = {
                qa:{
                    title: '',
                },
            };
            this.results = [];
        },

        handleShowMessage: function(msgData) {
            this.resetScene();
            if (!msgData) return;
            this.qaData = msgData;
            this.qaId = msgData.qa.id.toUpperCase();
            this.isHistory = false;
            msgData.qa.results.forEach(r => {
                if (r.attachmentUrl) {
                    r.attachmentUrl += r.attachmentUrl.includes('?') ? `&t=${Date.now()}` : `?t=${Date.now()}`;
                }
                this.results.unshift(r);
            });

            this.showData();
            // if (!this.isShow) return;
            // this.isShow = true;
            // if (msgData.results.length <= 0) return;
        },

        handleHistoryMessage: function(msgData) {
            // if (!msgData) return;
            if (!this.isHistory) this.resetScene();
            this.qaData.qa.title = '历史记录';
            this.isHistory = true;
            if (msgData.results.length <= 0) return;
            let lenId = msgData.results[0].msgId.toUpperCase();
            msgData.results.forEach(r => {
                if (r.attachmentUrl) {
                    r.attachmentUrl += r.attachmentUrl.includes('?') ? `&t=${Date.now()}` : `?t=${Date.now()}`;
                }
                this.results.unshift(r);
            });

            this.showData(lenId);
        },

        handleNewMessage: function(msgData) {
            if (!msgData) return;
            // if (this.isHistory) return;
            this.qaData.memberCount = msgData.memberCount;
            msgData.result.miUuid = msgData.result.miUuid.toUpperCase();
            msgData.result.msgId = msgData.result.msgId.toUpperCase();
            this.results.push(msgData.result);

            this.showData();
        },

        handleRevokMessage: function(msgData) {
            msgData.miUuid = msgData.miUuid.toUpperCase();
            let index = this.results.findIndex(ele => ele.miUuid === msgData.miUuid);
            // let refIndex = this.results.find(ele => ele.refMsg.miUuid === msgData.miUuid);
            if (!index) return;
            this.results.splice(index,1);
            this.results.forEach((r,index) => {
                if (r.refMsg === null) return;
                if (r.refMsg.miUuid == msgData.miUuid) {
                    r.refMsg.msgType = 'txt';
                    r.refMsg.content = '此条消息已被撤回';
                    this.$set(this.results,index,r);
                }
            });
        },

        handleLikeMessage: function(msgData) {
            if (!msgData) return;
            msgData.likeData.miUuid = msgData.likeData.miUuid.toUpperCase();
            let index = this.results.findIndex(ele => ele.miUuid === msgData.likeData.miUuid);
            let {score, scoreCount, likeCount, whoLike} = msgData.likeData;
            this.results[index].likeCount = likeCount;

            if (!msgData.likeData.score) return;
            this.results[index].likeScore = scoreCount;
            if (this.isLock) return;
            
            const avatar = document.querySelector('#result-img-box-' + msgData.likeData.miUuid).querySelector('.user-img');
            this.wings.pushAnimation(avatar, this.results[index].user.fullName, '+' + score);
        },

        handleCancelLikeMessage: function(msgData) {
            if (!msgData) return;
            msgData.likeData.miUuid = msgData.likeData.miUuid.toUpperCase();
            let index = this.results.findIndex(ele => ele.miUuid === msgData.likeData.miUuid);
            let {scoreCount = 0, likeCount = 0, whoLike} = msgData.likeData;
            this.results[index].likeCount = likeCount;
            this.results[index].likeScore = scoreCount;
        },

        showData: function(msg) {
            if (this.results.length <= 0) return;
            this.qaData.qa.subject = tool.htmlspecialchars(this.qaData.qa.subject || '') || '';

            let nowStamp = new Date(new Date().toLocaleDateString()).getTime();
            this.results.forEach((q,index) => {
                q.miUuid = q.miUuid.toUpperCase();
                q.msgId = q.msgId.toUpperCase();
                if (q.refMsg != null) {
                    q.refMsg.miUuid = q.refMsg.miUuid.toUpperCase();
                    q.refMsg.msgId = q.refMsg.msgId.toUpperCase();
                };

                q.isPlay = false;
                if (q.refMsg) q.refMsg.isPlay = false;

                if (!q.contentChange) {
                    q.content = tool.htmlspecialchars(q.content);
                    q.contentChange = true;
                };

                this.mediaDataShow(q);

                if (q.refMsg !== null) {
                    q.refMsg.ref = true;
                    this.mediaDataShow(q.refMsg);
                };

                this.showTime(q,index,nowStamp);
                
            });

            this.$nextTick(() => {
                let len = this.results.length - 1;
                let positions = this.$refs.positions;
                let resultsBox = this.$refs.resultsBox;
                let box = document.querySelector('#result-box-' + this.results[len].msgId);
                
                
                if (this.isHistory && !msg) return;
                if (this.isHistory && msg) {
                    box = document.querySelector('#result-box-' + msg);
                    this.$refs.positions.scrollTop = this.$refs.positions.scrollHeight;
                    return;
                };

                if (this.maxBottom > 400) return;
                // box.scrollIntoView(false);
                this.$refs.positions.scrollTop = this.$refs.positions.scrollHeight;

                this.maxBottom = resultsBox.getBoundingClientRect().height - positions.scrollTop - positions.getBoundingClientRect().height;
                if (positions.scrollTop === 0 ) positions.scrollTop = resultsBox.getBoundingClientRect().height;
            });
        },

        showTime: function(data,index,nowStamp) {
            if (!data) return;
            let stamp = 0;
            let distenceTime = (nowStamp - data.tsTs) / 1000;
            
            if (index === 0) stamp = data.tsTs;
            if (index !== 0) stamp = (this.results[index].tsTs - this.results[index-1].tsTs) / 1000;

            if (stamp <= 60) {
                data.stamp = null;
            } else {
                if (distenceTime <= 0) {
                    data.stamp = '今天 ' + moment(data.tsTs).format('HH:mm');
                } else if (0 < distenceTime && distenceTime <= 86400) {
                    data.stamp = '昨天' + moment(data.tsTs).format('HH:mm');
                } else {
                    data.stamp = moment(data.tsTs).format('YYYY-MM-DD HH:mm:ss');
                }
            };
            
            
        },

        mediaDataShow: function(data) {
            if (!data.msgType) return;
            if (data.msgType === 'img' || data.msgType == 'video') {
                // console.log(data);
                // console.log(data.attachmentWidth)
                let iWidth,iHeight;
                if (data.attachmentWidth === null || data.attachmentHeight === null) {
                    iWidth = 'max-width:';
                    iHeight = 'max-height:';
                } else {
                    iWidth = 'width:';
                    iHeight = 'height:';
                };
                const size = this.calcImageDisplaySize(data.attachmentWidth, data.attachmentHeight);
                if (data.ref) {
                    size.boxWidth = size.boxWidth.slice(0,size.boxWidth.search('p')) / 2 + 'px';
                    size.boxHeight = size.boxHeight.slice(0,size.boxHeight.search('p')) / 2 + 'px';
                    if (size.displayWidth === 'auto') size.displayWidth === 'auto';
                    if (size.displayWidth !== 'auto') size.displayWidth = size.displayWidth.slice(0,size.displayWidth.search('p')) / 2 + 'px';
                    if (size.displayHeight === 'auto') size.displayHeight === 'auto';
                    if (size.displayHeight !== 'auto') size.displayHeight = size.displayHeight.slice(0,size.displayHeight.search('p')) / 2 + 'px';
                    
                }
                
                data.imageBoxStyleString = [iWidth, size.boxWidth, ';' + iHeight, size.boxHeight].join('');
                data.imageStyleString = [iWidth, size.displayWidth, ';' + iHeight, size.displayHeight].join('');
            };

        },

        calcImageDisplaySize: function(imageWidth, imageHeight) {
            if (! imageWidth || ! imageHeight || imageWidth <= 0 || imageHeight <= 0) {
                // console.log('can not calculate the image disaplay size');
                return {
                    boxWidth: '500px',
                    boxHeight: '200px',
                    displayWidth: '500px',
                    displayHeight: '200px'
                };
            }

            const maxWidth = 500;
            const maxHeight = 200;

            if (imageWidth <= maxWidth && imageHeight <= maxHeight) {
                return {
                    boxWidth: imageWidth + 'px',
                    boxHeight: imageHeight + 'px',
                    displayWidth: imageWidth + 'px',
                    displayHeight: imageHeight + 'px'
                };
            } 

            if (imageHeight / imageWidth >= 2) {
                return {
                    boxWidth: '100px',
                    boxHeight: '200px',
                    displayWidth: '100px',
                    displayHeight: 'auto'
                };
            }

            if (imageWidth / imageHeight >= 5) {
                return {
                    boxWidth: '500px',
                    boxHeight: '100px',
                    displayWidth: 'auto',
                    displayHeight: '100px'
                };
            }

            let xFactor = imageWidth / maxWidth;
            let yFactor = imageHeight / maxHeight;
            if (xFactor > yFactor) {
                return {
                    boxWidth: '500px',
                    boxHeight: (imageHeight / xFactor).toFixed(0) + 'px',
                    displayWidth: '500px',
                    displayHeight: 'auto'
                };
            } else {
                return {
                    boxWidth: (imageWidth / yFactor).toFixed(0) + 'px',
                    boxHeight: '200px',
                    displayWidth: 'auto',
                    displayHeight: '200px'
                };
            }
        },

        expandResult: function() {
            this.hasTopic = true;
        },

        collapseResult: function() {
            this.hasTopic = false;
        },

        handleShowFiles: function(msgData) {
            if (!msgData) return;
            msgData.id = msgData.id.toUpperCase();
            let filesObj = {
                id: msgData.id,
                src: msgData.data.url
            };
            if (msgData.type === 'QA_MSG') {
                filesObj.ref = false;
            } else if (msgData.type === 'QA_REF_MSG') {
                filesObj.ref = true;
            } else {
                return;
            };

            if (msgData.data.msgType === 'img') this.showImage(filesObj);
            if (msgData.data.msgType === 'audio') this.showAudio(filesObj);
            if (msgData.data.msgType === 'video') this.showVideo(filesObj);
        },

        handleHideFiles: function(msgData) {
            if (!msgData) return;
            msgData.id = msgData.id.toUpperCase();
            if (msgData.type === 'QA_MSG' && this.selectedAudio != null) {
                this.showAudio({
                    id: msgData.id,
                    src: null,
                    ref: false
                });
            } else if (msgData.type === 'QA_REF_MSG' && this.selectedAudio != null) {
                this.showAudio({
                    id: msgData.id,
                    src: null,
                    ref: true
                });
            } else {
                if (this.selectedImage != null) this.selectedImage = null;
            }

            if (this.selectedAudio != null) this.selectedAudio = null;
            if (this.selectedVideo != null) this.selectedVideo = null;
        },

        showImage: function(imgObject) {
            if (! imgObject || ! imgObject.src) return;
            let loadingWidth = 100;
            let loadingHeight = 100;
            this.moveX = this.moveY = this.rotate = 0;

            this.selectedImage = {
                id: imgObject.id,
                src: loading,
                styleString: 'left: ' + Math.round(window.innerWidth - loadingWidth) / 2 + 'px; top: ' + Math.round(window.innerHeight - loadingHeight) / 2 + 'px; transform: scale(1.0);',
                baseFactor: 1.0
            };

            let tempImage = new Image();
            tempImage.addEventListener('load', () => {
                let factor = 1.0;

                if (tempImage.width < window.innerWidth && tempImage.height < window.innerHeight) {

                } else {
                    factor = Math.max(tempImage.width / window.innerWidth, tempImage.height / window.innerHeight);
                }
                factor = 1 / factor;

                this.selectedImage = {
                    id: imgObject.id,
                    src: tempImage.src,
                    styleString: 'left: ' + Math.round(window.innerWidth - tempImage.width) / 2 + 'px; top: ' + Math.round(window.innerHeight - tempImage.height) / 2 + 'px; transform: scale(' + factor + ');',
                    baseFactor: factor
                };

                this.selectedImageScale = factor;
            });
            tempImage.src = imgObject.src;

        },

        showAudio: function(audioObj) {
            if (!audioObj) return;
            this.selectedAudio = {
                id: audioObj.id,
                src: audioObj.src,
            };
            let index = null;
            if (!audioObj.ref) {
                index = this.results.findIndex(ele => ele.miUuid === audioObj.id);
                if (index < 0) return;
                this.results[index].isPlay = !this.results[index].isPlay;
            } else {
                this.results.forEach((r,ind) => {
                    if (!r.refMsg) return;
                    // if (ind < 0) return;
                    if (r.refMsg.miUuid === audioObj.id) {
                        r.refMsg.isPlay = !r.refMsg.isPlay;
                        index = ind;
                    };
                });
            };
            
            // console.log(index);
            
            this.$nextTick(() => {
                if (typeof index !== 'number') return;
                let box = document.querySelector('#result-box-' + this.results[index].msgId);
                box.scrollIntoView(false);

                if (audioObj.src) {
                    // this.$refs.selectedAudioBox.play();
                    const ret = this.$refs.selectedAudioBox.play();
                    if (ret && (typeof ret.then === 'function')) {
                        ret.catch(err => {
                            console.log('can not play audio');
                        });
                    };
                };
            });
        },

        /**
         * show video 
         * @param {object} videoData video data, key: id/src
         */
        showVideo: function(videoData) {
            if (!videoData) return;
            this.selectedVideo = {
                id: videoData.id,
                url: videoData.src
            }
        },

        rotateImg: function(msgData) {
            this.rotate += 90;
            this.$refs.selectedImage.style.transform = tool.getImgStyle(this.selectedImageScale, this.moveX, this.moveY, this.rotate);
        },

        // zoom to resultImage
        zoomTo: function(msgData) {
            this.moveX = 0;
            this.moveY = 0;
            // if (msgData.id != this.selectedImage.id) return;
            let newFactor = msgData.scaleFactor.toFixed(4);
            this.selectedImageScale = newFactor;
            this.$refs.selectedImage.style.transform = tool.getImgStyle(this.selectedImageScale, this.moveX, this.moveY, this.rotate);
        },

        moveJoystick: function(msgData) {
            let box = null;
            let positions = this.$refs.positions;
            let resultsBox = this.$refs.resultsBox;
            let expandResultBox = this.$refs.expandResultBox;
            let direction = msgData.direction;
            if (this.selectedImage != null) {
                this.moveForSelectedImage(direction);
            } else if (this.selectedResult != null) {
                box = expandResultBox;
                this.justUpAndDown(direction,box);
            } else if (this.selectedImage != null) {
                this.moveForSelectedImage(direction);
            } else {
                box = positions;
                this.justUpAndDown(direction,box);
            }
            this.maxBottom = resultsBox.getBoundingClientRect().height - positions.scrollTop - positions.getBoundingClientRect().height;
            // console.log(this.maxBottom);
        },

        justUpAndDown: function(direction,box) {
            
            if (direction === 'LEFT') {
                return;
            } else if (direction === 'RIGHT') {
                return;
            } else if (direction === 'UP') {
                box.scrollTop -= 40;
                // box.scrollIntoView();
            } else if (direction === 'DOWN') {
                box.scrollTop += 40;
                // box.scrollIntoView();
            } else {
                return;
            }
            // this.isScroll = true;
        },

        moveForSelectedImage: function(direction) {
            if (direction === 'LEFT') {
                this.moveX += 40;
            } else if (direction === 'RIGHT') {
                this.moveX -= 40;
            } else if (direction === 'UP') {
                this.moveY += 40;
            } else if (direction === 'DOWN') {
                this.moveY -= 40;
            } else {
                return;
            }

            this.$refs.selectedImage.style.transform = tool.getImgStyle(this.selectedImageScale, this.moveX, this.moveY, this.rotate);
        },

        scrollToTop: function() {
            let positions = this.$refs.positions;
            // let positionsUl = this.$refs.positionsUl;
            // console.log(positions.scrollTop,positionsUl.getBoundingClientRect().height);
            // positions.scrollTop += positionsUl.getBoundingClientRect().height;
            console.log(positions.scrollTop);
        }, 

        /**
         * get msg role class
         * @param {number} roleId 
         * @returns {string}
         */
        getRoleClass(user) {
            if (!user || !user.userId) return 'stu-results';
            var className = '';
            if (user.userId !== this.userId) {
                className = 'stu-results';
            } else {
                className = 'teach-results';
            }
            return className;
        }, 

        /**
         * parse 90s to 01: 30
         * @param {number} second 
         * @returns {string}
         */
        parseSecond(second) {
            if (!second) return '00:00';
            let sec = +second;
            let m = Math.floor(sec / 60);
            let s = Math.ceil(sec % 60);
            m < 10 ? m = `0${m}` : '';
            s < 10 ? s = `0${s}` : '';
            return `${m}:${s}`;
        }
    }
};
</script>

<style scoped>
    .qa-box {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .title-bar {
        display: flex;
        position: relative;
        align-items: flex-start;
        justify-content: space-between;
        padding: 20px 40px;
        box-sizing: border-box;
        background-color: #191919;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 9;
        font-size: 24px;
        color: #ffffff;
    }

    .title-bar .led-timer {
        /* width: 320px; */
        flex-grow: 0;
    }

    .title-bar .stat-info {
        flex-grow: 0;
        line-height: 36px;
        display: flex;
        justify-content: flex-end;
        position: absolute;
        right: 40px;
    }

    .title-bar .stat-info > span {
        line-height: 36px;
    }

    .title-bar .stat-info > span:last-child {
        margin-left: 10px;
        font-size: 30px;
    }

    .title-bar .title {
        width: 600px;
        line-height: 40px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        text-align: center;
        font-size: 24px;
        color: #ffffff;
        /* flex-grow: 1; */
    }

    .title-bar .title.no-timer {
        flex-grow: 1;
    }

    .empty-result-hint {
        position: absolute;
        left: 0px;
        top: 80px;
        right: 0px;
        bottom: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .empty-result-hint .hint-content {
        width: 312px;
        padding-top: 230px;
        background-image: url('../assets/image/qa_icon.png');
        background-size: 200px 200px;
        background-position: 50% 0;
        background-repeat: no-repeat;
        font-size: 24px;
        color: #ffffff;
    }

    .positions{
        width: 100%;
        position: fixed;
        top: 80px;
        left: 0;
        bottom: 0;
        right: 0;
        overflow-x: hidden;
        overflow-y: auto;
    }

    /* .voice-img {
        width: 25px;
        height: 36px;
    } */

    .results-title {
        background-color: #191919;
        padding: 10px 40px;
        text-align: left;
        overflow-x: hidden;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .results-title .text-content {
        font-size: 1.5rem;
        color: #BBC2C6;
    }

    .jiao {
        width: 0;
        height: 0;
        border-color: red;
        border-top-color: black;
        border-bottom-color: black;
        border-left-color: black;
        border-width: 10px;
        /* border-bottom-width: 5px;
        border-left-width: 5px;*/
        border-right-width: 15px;
        border-style: solid;
    }

    .results-box {
        width: 100%;
        color: #ffffff;
        padding: 0px 75px;
        box-sizing: border-box;
    }

    .result-main {
        font-size: 24px;
        line-height: 24px;
        margin: 40px;
        margin-bottom: 80px;
    }

    .result-time {
        margin-bottom: 40px;
        color: #BBC2C6;
    }

    .result-body {
        display: flex;
        
        /* justify-content: flex-end; */
        /* align-items: baseline; */
    }

    .user-box {
        position: relative;
    }

    
    
    .teach-results {
        flex-direction: row-reverse;
    }

    .stu-results {
        flex-direction: row;
    }

    .user-img {
        width: 80px;
        height: 80px;
        border: 4px solid #ffffff;
        border-radius: 50%;
        box-sizing: border-box;
        align-items: center;
    }

    .result-content .result-msg {
        min-width: 340px;
        max-width: 725px;
        font-size: 1.5rem;
        line-height: 2.5rem;
        padding: 0 24px;
        box-sizing: border-box;
        border-radius: 8px;
        position: relative;
    }

    .teach-results > .result-content > .result-msg {
        background: #4A7FB5;
    }

    .teach-result-msg:before {
        content: '';
        display: block;
        width: 24px;
        height: 24px;
        background: #4A7FB5;
        position: absolute;
        top: 30px;
        right: -12px;
        transform: rotate(45deg);
    }

    .stu-result-msg:before {
        content: '';
        display: block;
        width: 24px;
        height: 24px;
        background: #e1e1e1;
        position: absolute;
        top: 30px;
        left: -12px;
        transform: rotate(45deg);
    }

    .ref-msg-box {
        padding: 24px 0;
        box-sizing: border-box;
    }

    .teach-results .ref-msg-box {
        color: rgba(255,255,255,0.70);
        border-bottom: 1px solid #cccccc;
    }

    .teach-results .ref-msg-box1 {
        display: flex;
        justify-content: flex-end;
    }

    .stu-results .ref-msg-box {
        color: #666666;
        border-bottom: 1px solid #cccccc;
    }

    .res-msg-box {
        padding: 24px 0;
        box-sizing: border-box;
    }

    .res-img-box, .ref-img-box {
        overflow: hidden;
    }

    .teach-results .res-msg-box {
        color: #ffffff;
    }

    .img-left {
        display: flex;
        justify-content: flex-end;
    }

    .stu-results > .result-content > .result-msg {
        background: #e1e1e1;
        color: #000000;
    }

    .stu-results .has-answer {
        color: #666666;
    }

    .teach-results .has-answer {
        color: rgba(255, 255, 255, 0.7);
    }

    .res-answer span , .ref-msg-box p , .text-content span{
        word-break: break-all;
    }

    .like-Count {
        align-self: flex-end;
        display: flex;
        /* margin-right: 10px; */
    }

    .result-like-count {
        align-self: flex-end;
        width: 30px;
        height: 30px;
        background: url("../assets/image/like-count-0.png") 0 0 no-repeat;
        background-size: 30px 30px;
    }

    .result-like-count1 {
        align-self: flex-end;
        font-size: 24px;
        line-height: 24px;
        margin-right: 10px;
    }

    .stu-like-count1 {
        /* padding-bottom: 30px; */
    }

    .stu-like-count {
        /* padding-bottom: 30px; */
        background: url("../assets/image/like-count.png") 0 0 no-repeat;
        background-size: 30px 30px;
    }
    
    .stu-results .result-like-count {
        margin-left: 10px;
        margin-right: 10px;
    }

    .teach-results .result-like-count {
        margin-right: 10px;
    }

    .result-like-score {
        margin-top: 10px;
    }

    .ref-audio-box,.res-audio-box {
        height: 36px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .teach-results .res-audio-box {
        align-items: center;
        flex-direction: row-reverse;
    }

    .stu-results .ref-audio-box {
        align-items: center;
        flex-direction: row-reverse;
    }

    .res-audio-box > div:first-child , .ref-audio-box > div:first-child{
        display: flex;
    }

    /* .ref-audio-box .voice-icon , .res-audio-box .voice-icon {
        transform-origin: center;
    } */

    .res-audio-box > div:first-child > svg , .ref-audio-box > div:first-child > svg {
        /* width: 25px; */
        /* height: 36px; */
    }
    .res-audio-box > div:first-child > img , .ref-audio-box > div:first-child > img {
        width: 25px;
        height: 36px;
    }

    #voice_icon_white {
        transform-origin: center;
    }

    .voice-icon {
        fill-opacity: 1;
        transform-origin: center;
    }

    .teach-results .res-audio-box .voice-icon {
        fill: #ffffff;
    }
    
    .teach-results .res-audio-box > div:first-child > img {
        fill: #ffffff;
        transform: rotate(180deg);
        
    }

    .stu-results .res-audio-box .voice-icon ,.stu-results .res-audio-box > div:first-child > img {
        fill: #333333;
    }

    .teach-results .ref-audio-box .voice-icon ,.teach-results .ref-audio-box > div:first-child > img {
        fill: rgba(255,255,255,0.7);
    }

    

    .stu-results .ref-audio-box .voice-icon {
        fill: #666666;
        /* transform: rotate(180deg); */
        /* transform-origin: center; */
    }

    .teach-results .ref-audio-box > div:first-child > img {
        transform: rotate(0);
    }

    .stu-results .ref-audio-box > div:first-child > img {
        transform: rotate(0deg);
    }

    .expand-image-box {
        position: fixed;
        overflow: hidden;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 9;
    }

    .expand-image-box img {
        position: absolute;
        /* transition: transform 300ms linear; */
    }

    .expand-audio-box {
        width: 0;
        height: 0;
    }

    .imgAnimation {
        animation: load 1s;
        animation-timing-function: linear;
        animation-direction: reverse;
        animation-iteration-count: infinite;
    }

    @keyframes load {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(-360deg);
        }
    }
    .video-duration {
        position: absolute;
        right: 6px;
        bottom: 6px;
        font-size: 12px;
        line-height: 12px;
        color: #fff;
    }
    .res-video-box {
        display: flex;
    }
    .video-img-box {
        position: relative;
        display: flex;
        min-width: 52px;
    }
    .video-img-box.video-img-box-model::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
    }
    .video-left .video-img-box {
        margin-left: auto;
    }
    .video-play-icon {
        position: absolute;
        width: 48px;
        height: 48px;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
    }
    .expand-video-box {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
    }
    .user-flag {
        border-radius: 4px;
        width: 80px;
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
    }
    .user-title {
        display: flex;
        margin-bottom: 10px;
    }
    .stu-results .user-flag {
        margin-right: 20px;
    }
    .stu-results .user-title {
        margin-right: 20px;
    }
    .stu-results .teacher {
        justify-content: flex-start;
    }
    .like-position .stu-like-count {
        padding-bottom: 30px;
    }
    .like-position .stu-like-count1{
        padding-bottom: 30px;
    }



    .stu-results > .result-content {
        text-align: left;
        margin-left: 50px;
    }

    .teach-results > .result-content {
        text-align: left;
        margin-right: 50px;
    }

    .teacher , .student {
        display: flex;
        margin-bottom: 10px;
    }

    .student > span , .teacher > span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size: 24px;
        line-height: 24px;
    }
    span.user-flag {
        font-size: 18px;
    }
    .teacher-flag {
        background: #FF6600;
    }
    .supervisor-flag {
        background: #0bd;
    }
    .assistant-flag {
        background: #FF7D44;
        border-radius: 4px;
        width: 80px;
        height: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px!important;
    }
    .assistant .user-fn {
        margin-left: 20px!important;
        max-width: 200px!important;
    }
    .assistant .user-no {
        margin-left: 20px!important;
        max-width: 300px!important;
    }


    .teach-results span.user-flag {
        width: 80px;
        height: 26px;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        border-radius: 4px;
        margin-left: 20px;
    }
    .teach-results .user-title {
        display: flex;
        flex-direction: row-reverse;
    }
    .teach-results .student .user-fn {
        margin-left: 20px;
    }

    .student > span.user-fn , .teacher > span.user-fn {
        max-width: 200px;
    }

    .student > span.user-no {
        max-width: 300px;
        margin-left: 20px;
    }

    .stu-results .user-title {

    }
</style>


